exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dot-loader {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: white;\n  padding-top: 30px;\n  margin-bottom: 20px;\n  font-size: 22px;\n  font-weight: 300;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: normal;\n  letter-spacing: normal; }\n  .dot-loader .dots {\n    display: flex;\n    flex-direction: row;\n    margin-right: 20px; }\n    .dot-loader .dots .dot {\n      width: 16px;\n      height: 16px;\n      background-color: white;\n      border-radius: 8px;\n      margin: 0 5px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/DotLoader.scss
// module id = 708
// module chunks = 0